module.exports = __webpack_public_path__ + "img/how-four.921406b9.svg";